import { render, staticRenderFns } from "./PurchaseDuoTable.vue?vue&type=template&id=cef011d0&"
import script from "./PurchaseDuoTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports